var map = {
	"./2.mp3": "2b90",
	"./unidad3/AUDIO-01.mp3": "4ce3",
	"./unidad3/AUDIO-02.mp3": "6e9f",
	"./unidad3/AUDIO-03.mp3": "42bc",
	"./unidad3/AUDIO-04.mp3": "2c9e",
	"./unidad3/AUDIO-05.mp3": "c623",
	"./unidad3/AUDIO-06.mp3": "072d",
	"./unidad3/AUDIO-07.mp3": "3cb9",
	"./unidad3/AUDIO-08.mp3": "c7a5",
	"./unidad3/AUDIO-09.mp3": "2972",
	"./unidad3/AUDIO-10.mp3": "6a6d",
	"./unidad3/AUDIO-11.mp3": "aad7",
	"./unidad3/AUDIO-12.mp3": "24ba",
	"./unidad3/AUDIO-13.mp3": "d77a",
	"./unidad3/AUDIO-14.mp3": "9349",
	"./unidad3/AUDIO-15.mp3": "9eab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d75d";